import CardElementText from './CardElementText';

export default CardElementText;
